export default {
  nav: {
    coreLogic: 'Lógica Central',
    profitMechanism: 'Mecanismo de Ganancias',
    profitFlywheel: 'Volante de Ganancias',
    sysArch: 'Arquitectura del Sistema',
    tradingExample: 'Casos de Trading',
    cta: 'Empezar',
    language: 'Idioma',
  },
  hero: {
    badge: 'Poly Ai Claw Intelligence Engine',
    title1: 'De la Predicción al',
    title2: 'Arbitraje de Probabilidad',
    desc: 'Polywin actualiza los mercados de predicción a un motor de arbitraje sistemático impulsado por el Poly Ai Claw Intelligence Engine',
    ctaPrimary: 'Activar Poly Ai Claw Engine',
    ctaSecondary: 'Ver Demo',
    statsEvents: 'Eventos Monitoreados',
    statsSuccessRate: 'Tasa de Éxito',
    statsExecTime: 'Tiempo de Ejecución',
    cardTitle: 'Análisis de Desviación de Probabilidad',
    cardBadge: 'Zona de Ventaja EV',
    cardMarketProb: 'Probabilidad del Mercado',
    cardAiProb: 'Probabilidad AI',
    cardMarketImplied: 'Probabilidad Implícita del Mercado',
    cardAiTrue: 'Probabilidad Real AI',
    cardProbDiff: 'Ventaja de Probabilidad',
  },
  coreLogic: {
    badge: 'Sistema de Decisión PolyAi-Claw',
    title1: 'De la Agregación de Datos a los Retornos Compuestos —',
    title2: 'Bucle Completamente Automatizado',
    desc: 'Datos multifuente → IA → Desviación de probabilidad → Ejecución automática → Retornos compuestos',
    step0_title: 'Capa de Datos',
    step0_sub: 'Agregación Multifuente',
    step0_i0: 'Eventos Políticos',
    step0_i1: 'Macroeconomía',
    step0_i2: 'Sentimiento Social',
    step0_i3: 'Datos del Libro de Órdenes',
    step1_title: 'Modelado AI',
    step1_sub: 'Actualización de Probabilidad Bayes',
    step1_i0: 'Entrada de Datos en Tiempo Real',
    step1_i1: 'Motor de Modelado AI',
    step1_i2: 'Cálculo de Probabilidad',
    step1_i3: 'Optimización del Modelo',
    step2_title: 'Detección de Desviación',
    step2_sub: 'Identificación de Desviación de Probabilidad',
    step2_i0: 'Probabilidad Implícita del Mercado',
    step2_i1: 'Probabilidad Real AI',
    step2_i2: 'Identificación de Ventaja EV',
    step2_i3: 'Señal de Posición',
    step3_title: 'Ejecución On-chain',
    step3_sub: 'Trading Automático Polygon',
    step3_i0: 'Control de Riesgo',
    step3_i1: 'Asignación de Capital',
    step3_i2: 'Liquidación USDC',
    step3_i3: 'Contrato Inteligente',
    step4_title: 'Retornos Compuestos',
    step4_sub: 'Reinversión Automática',
    step4_i0: 'Liquidación de Evento',
    step4_i1: 'Liquidación de Ganancias',
    step4_i2: 'Cálculo Compuesto',
    step4_i3: 'Bucle de Reinversión',
    keyTitle: 'Objetivo Central',
    keyDesc: 'El objetivo de PolyAi-Claw es encontrar continuamente errores de precio de probabilidad (Mispricing) en el mercado y ejecutar arbitraje sistemático.',
    keyHighlight: 'encontrar errores de precio de probabilidad y ejecutar arbitraje sistemático',
  },
  profitMechanism: {
    badge: 'Mecanismo de Ganancias Central',
    title1: '3 Mecanismos de Ganancias de',
    title2: 'PolyAi-Claw',
    desc: 'Sistema de arbitraje de probabilidad estable mediante detección de ventaja EV, ejecución en milisegundos y gestión de capital en 3 niveles',
    m1_title: 'Detección de Ventaja EV',
    m1_sub: 'Probability Edge Detection',
    m1_desc: 'Lógica central: Precio del mercado ≠ Probabilidad real. Cuando la IA detecta una desviación, el sistema entra automáticamente en la zona EV y activa una posición.',
    m1_marketImplied: 'Probabilidad Implícita del Mercado',
    m1_aiTrue: 'Probabilidad Real AI',
    m1_probDiff: 'Ventaja de Probabilidad',
    m1_note: 'Mismo principio que el arbitraje de opciones de fondos quant',
    m2_title: 'Ejecución Automática en Milisegundos',
    m2_sub: 'Millisecond Execution',
    m2_desc: 'Marco de ejecución completamente automatizado que garantiza que las oportunidades de arbitraje no se pierdan.',
    m2_i0_title: 'Velocidad de Ejecución en Milisegundos',
    m2_i0_sub: 'Promedio <200ms',
    m2_i1_title: 'Completamente Transparente On-chain',
    m2_i1_sub: 'Polygon PoS',
    m2_i2_title: 'Sin Interferencia Humana',
    m2_i2_sub: 'Liquidación Automática de Contrato Inteligente',
    m2_network_label: 'Red de Ejecución',
    m2_network_val: 'Polygon + USDC',
    m3_title: 'Gestión de Capital en 3 Niveles',
    m3_sub: 'Three-Tier Risk Control',
    m3_desc: 'Evita el alto apalancamiento y el riesgo de un solo punto en la especulación tradicional.',
    m3_i0_title: 'Pool de Retorno Estable',
    m3_i0_desc: 'Arbitraje de probabilidad de alta certeza, menor riesgo',
    m3_i1_title: 'Pool de Arbitraje de Volatilidad',
    m3_i1_desc: 'Captura la volatilidad del mercado, alta elasticidad de retornos',
    m3_i2_title: 'Pool de Protección de Cobertura',
    m3_i2_desc: 'Cobertura de eventos de baja correlación, reduce el riesgo sistémico',
    m3_risk: 'Exposición por Evento < 5%',
    formula_title: 'Fórmula de Arbitraje de Probabilidad',
    formula_marketPrice: 'Precio del Mercado',
    formula_aiTrue: 'Probabilidad Real AI',
    formula_trigger: 'Activar Posición',
    formula_arbitrage: 'Arbitraje',
    formula_hiddenPct: 'Implícito 60%',
    formula_evEdge: 'Ventaja EV +12%',
    formula_autoExec: 'Ejecución Automática',
  },
  fundManagement: {
    riskTitle: 'Principios Centrales de Control de Riesgo',
    riskDesc: 'El sistema establece exposición máxima por evento < 5%.',
    riskHighlight: 'exposición máxima por evento < 5%',
    stat_maxSingle: 'Inversión Máxima por Vez',
    stat_maxSingleVal: '5%',
    stat_diversify: 'Diversificación de Capital',
    stat_diversifyVal: '20+ Eventos',
    stat_stopLoss: 'Mecanismo de Stop-loss',
    stat_stopLossVal: 'Auto-activado',
    vizTitle: 'Visualización de Datos de Control de Riesgo',
    viz_exposure: 'Control de Exposición',
    viz_diversify: 'Diversificación',
    viz_correlation: 'Correlación de Eventos',
    viz_stability: 'Estabilidad de Estrategia',
  },
  techAdvantage: {
    badge: 'Ventajas Centrales',
    title1: '¿Por qué PolyAi-Claw es',
    title2: 'Superior a los Mercados de Predicción Tradicionales?',
    dim_decision: 'Base de Decisión',
    dim_monitor: 'Frecuencia de Monitoreo',
    dim_execute: 'Método de Ejecución',
    dim_model: 'Modelo Cognitivo',
    dim_risk: 'Control de Riesgo',
    human_decision: 'Impulsado por Emociones',
    human_monitor: 'Baja Frecuencia',
    human_execute: 'Órdenes Manuales',
    human_model: 'Subjetivo',
    human_risk: 'Basado en Experiencia',
    ai_decision: 'Basado en Datos',
    ai_monitor: 'Alta Frecuencia',
    ai_execute: 'Ejecución Automática',
    ai_model: 'Modelo de Probabilidad',
    ai_risk: 'Gestionado por Algoritmo',
    humanPredict: 'Predicción Humana',
    adv1_title: 'Datos vs Emociones',
    adv1_desc: 'PolyAi-Claw modela basándose en datos multifuente incluyendo eventos políticos, macroeconomía, sentimiento social.',
    adv1_label: 'Número de Fuentes de Datos',
    adv2_title: 'Alta Frecuencia vs Baja',
    adv2_desc: 'El sistema monitorea 24/7 sin interrupción, identificando oportunidades de desviación en tiempo real.',
    adv2_label: 'Frecuencia de Monitoreo',
    adv3_title: 'Automático vs Manual',
    adv3_desc: 'Ejecución automática en milisegundos a través de contratos inteligentes en la cadena Polygon, sin intervención humana.',
    adv3_label: 'Velocidad de Ejecución',
    adv4_title: 'Algoritmo vs Experiencia',
    adv4_desc: 'Sistema de gestión de capital en 3 niveles con exposición por evento estrictamente por debajo del 5%.',
    adv4_label: 'Control de Riesgo',
    conclusion_title: 'Del Mercado de Predicción al Poly Ai Claw Intelligence Engine',
    conclusion_desc1: 'Esto actualiza PolyWin de un simple Prediction Market a',
    conclusion_brand: 'Poly Ai Claw Intelligence Engine',
    conclusion_desc2: 'El Sistema de Predicción Cuantitativa Poly Ai Claw',
  },
  productNarrative: {
    badge: 'Posicionamiento del Producto',
    title: 'La Verdadera Identidad de PolyWin',
    desc: 'PolyWin no es solo un mercado de predicción, es un sistema integrado que combina IA, mercados de predicción, OpenClaw y trading cuantitativo.',
    item0_title: 'Sistema de Arbitraje de Probabilidad',
    item0_sub: 'Captura continuamente errores de precio',
    item1_title: 'Modelo de Ejecución Disciplinada',
    item1_sub: 'Automatizado, sin interferencia emocional',
    item2_title: 'Motor de Gestión de Riesgo AI',
    item2_sub: 'Control de riesgo inteligente',
    visual_title: '3 Expresiones Visuales',
    vis0_title: '① Gráfico de Desviación de Curva de Probabilidad',
    vis0_desc: 'Muestra la curva de probabilidad AI vs la curva de precio del mercado',
    vis0_ai: 'Probabilidad AI',
    vis0_market: 'Precio del Mercado',
    vis0_diff: 'Diferencia',
    vis1_title: '② Gráfico de Radar de Control de Riesgo',
    vis1_desc: 'Muestra exposición al riesgo, diversificación, correlación de eventos, estabilidad',
    vis1_exposure: 'Exposición al Riesgo',
    vis1_diversify: 'Diversificación',
    vis1_safe: 'Zona Segura',
    vis1_safeVal: 'Ingresado',
    vis2_title: '③ Diagrama de Flujo de Trading Automático AI',
    vis2_desc: 'Resalta el bucle completo: Datos → IA → Ejecución → Liquidación → Compuesto',
    vis2_exec: 'Velocidad de Ejecución',
    vis2_execVal: 'Milisegundos',
    vis2_auto: 'Tasa de Automatización',
    vis2_compound: 'Bucle Compuesto',
    vis2_compoundVal: 'Continuo',
    core_title: 'Propuesta de Valor Central',
    core_desc: 'A través de la fijación de precios de probabilidad automatizada y el mecanismo de composición, PolyAi-Claw captura continuamente desviaciones de precios manteniendo el control de riesgo.',
    core_highlight: 'fijación de precios de probabilidad automatizada y mecanismo de composición',
    core_item0: 'Fijación de Precios Automatizada',
    core_item1: 'Mecanismo de Composición',
    core_item2: 'Garantía de Control de Riesgo',
    core_item3: 'Captura Continua de Desviaciones',
  },
  profitFlywheel: {
    badge: 'Volante de Crecimiento Financiero Impulsado por IA',
    title1: 'PolyWin AI',
    title2: 'Modelo de Volante de Ganancias',
    desc: 'El crecimiento de PolyWin no depende de ganancias de un solo trade, sino de un sistema de composición continua impulsado por IA',
    descHighlight: 'sistema de composición continua impulsado por IA',
    aiCore: 'AI Probability Engine',
    step1_title: 'Entrada de Datos Globales',
    step1_sub: 'Global Data',
    step1_desc: 'IA monitorea continuamente noticias, cambios políticos, macroeconomía, sentimiento social, libro de órdenes',
    step1_tech: '50+ Fuentes de Datos',
    step1_techDetail: 'Fusión multifuente en tiempo real',
    step2_title: 'Modelado de Probabilidad AI',
    step2_sub: 'Probability Modeling',
    step2_desc: 'Usa modelos de probabilidad Bayes, modelos de corrección de sentimiento para calcular probabilidades reales',
    step2_tech: 'Modelo Bayes',
    step2_techDetail: 'Actualización dinámica de probabilidad en tiempo real',
    step3_title: 'Detectar Desviación de Probabilidad',
    step3_sub: 'Probability Edge',
    step3_desc: 'Cuando probabilidad real AI > probabilidad implícita del mercado, identificado como EV Positive Opportunity',
    step3_tech: 'Desviación EV >5%',
    step3_techDetail: 'Detección automática de EV positivo',
    step4_title: 'Ejecución de Trading Automático',
    step4_sub: 'Algorithmic Execution',
    step4_desc: 'El sistema completa automáticamente la construcción de posiciones, cobertura, ejecución de órdenes en la cadena Polygon',
    step4_tech: 'Contrato Inteligente',
    step4_techDetail: '<200ms ejecución en milisegundos',
    step5_title: 'Ganancias del Mercado de Predicción',
    step5_sub: 'Market Profit',
    step5_desc: 'Cuando el resultado del evento se confirma, el sistema obtiene retornos de arbitraje',
    step5_tech: 'Polygon PoS',
    step5_techDetail: 'Liquidación automática on-chain',
    step6_title: 'Recuperación de Capital',
    step6_sub: 'Capital Recycling',
    step6_desc: 'El sistema recupera automáticamente el capital de ganancias al pool de fondos',
    step6_tech: 'Liquidación USDC',
    step6_techDetail: 'Stablecoin sin pérdida de tipo de cambio',
    step7_title: 'Crecimiento Compuesto',
    step7_sub: 'Compounding Capital',
    step7_desc: 'A medida que el pool de fondos crece, la IA puede participar en mercados más grandes',
    step7_tech: 'Composición Automática',
    step7_techDetail: 'Bucle de reinversión automática de ganancias',
    step8_title: 'Mayor Escala de Capital',
    step8_sub: 'Larger Liquidity Pool',
    step8_desc: 'Mayor escala de capital significa mayor capacidad de trading y retornos más estables',
    step8_tech: 'Expansión de Liquidez',
    step8_techDetail: 'Cuanto mayor la escala, mayor la ventaja',
    sum0_label: 'Capa de Datos',
    sum0_tech: '50+ Flujos Multifuente',
    sum0_detail: 'Modelado Bayes en tiempo real',
    sum1_label: 'Capa de Ejecución',
    sum1_tech: 'Automatización de Contrato Inteligente',
    sum1_detail: 'Liquidación on-chain Polygon PoS',
    sum2_label: 'Capa de Liquidación',
    sum2_tech: 'USDC Stablecoin',
    sum2_detail: 'Liquidación sin pérdida de FX',
    sum3_label: 'Capa Compuesta',
    sum3_tech: 'Reinversión Automática',
    sum3_detail: 'Bucle de expansión de escala positivo',
    key0_title: 'Bucle de Autorrefuerzo',
    key0_desc: 'Cada ganancia fortalece las capacidades del sistema, formando bucles de retroalimentación positiva para crecimiento exponencial',
    key1_title: 'Crecimiento Impulsado por IA',
    key1_desc: 'El crecimiento no depende de referencias, sino de la capacidad de arbitraje de probabilidad del sistema IA',
    key2_title: 'Sistema de Composición Continua',
    key2_desc: 'La recuperación y reinversión automática de ganancias permite que el pool de fondos se expanda continuamente',
    formula_title: 'Fórmula de Crecimiento del Volante',
    f0_label: 'Datos AI',
    f1_label: 'Arbitraje',
    f2_label: 'Ganancias',
    f3_label: 'Composición',
    f4_label: 'Más Capital',
    f5_label: 'Más Arbitraje',
    connected: 'Conectado · En Vivo',
  },
  sysArch: {
    badge: 'Official Architecture',
    title1: 'PolyAi-Claw AI',
    title2: 'Arquitectura del Sistema',
    desc: 'Sistema de decisión AI completo desde la recopilación de datos hasta la liquidación automática',
    coreBadge: 'Cerebro AI Central',
    feat0_title: 'Estructura Completa del Sistema AI',
    feat0_desc: 'No es una estrategia simple, sino un sistema de decisión AI completo que abarca todo el flujo',
    feat1_title: 'Control de Riesgo de Nivel Fondo Quant',
    feat1_desc: 'Modelos de control de riesgo de fondos quant profesionales',
    feat2_title: 'Arquitectura Escalable',
    feat2_desc: 'Expandible a multi-mercado, multi-cadena, multi-estrategia',
    dataflow_title: 'Flujo de Datos',
  },
  tradingExample: {
    badge: 'Estudio de Caso Real',
    title1: 'PolyAi-Claw BTC',
    title2: 'Estrategia de Arbitraje de 5 Minutos',
    desc: 'El sistema solo hace 3 cosas: Detectar volatilidad anormal → Juicio de probabilidad en los últimos 60 segundos → Operar en la zona segura',
    s1_title: 'BTC Market Data',
    s1_sub: 'Monitoreo del Mercado en Tiempo Real',
    s1_notice: 'Datos de muestra de condiciones de activación de estrategia',
    s1_price: 'Precio Actual',
    s1_eg: 'Ejemplo',
    s1_priceVol: 'Volatilidad del Precio',
    s1_vol: 'Volumen',
    s1_depth: 'Profundidad del Libro de Órdenes',
    s1_trigger: 'Activación: Volatilidad ≥ 100 USD',
    s1_met: 'Cumplido',
    s2_title: 'PolyAi-Claw Engine',
    s2_sub: 'Cálculo de Probabilidad AI',
    s2_marketImplied: 'Probabilidad Implícita del Mercado',
    s2_aiTrue: 'Probabilidad Real AI',
    s2_yes: 'YES',
    s2_probDiff: 'Ventaja de Probabilidad',
    s2_safe: 'Entrando a la Zona de Trading Seguro',
    s3_title: 'Auto Trade + Profit',
    s3_sub: 'Ejecución Automática y Ganancias',
    s3_exec: 'Ejecución de Trading',
    s3_buyYes: 'Comprar YES',
    s3_buyPrice: 'Precio de Entrada',
    s3_settlement: 'Liquidación del Mercado de Predicción',
    s3_correct: 'Predicción Correcta',
    s3_profit: 'Ganancia por Trading',
    s3_avg: 'Tasa de Ganancia Promedio',
    s3_recycle: 'Ganancias Recicladas al Pool',
    chart_title: 'Gráfico de Desviación AI vs Mercado',
    chart_sub: 'Seguimiento en tiempo real de la desviación de probabilidad Poly Ai Claw vs mercado',
    chart_live: 'Live Analysis',
    chart_curDev: 'Desviación Actual',
    chart_signal: 'Señal de Arbitraje',
    chart_signalVal: 'Activado',
    chart_winRate: 'Pronóstico de Win Rate',
    chart_bottom_implied: 'Probabilidad Implícita',
    chart_bottom_dev: 'Zona de Desviación',
    chart_bottom_dev_sub: 'Oportunidad de arbitraje activada',
    chart_bottom_ai: 'Probabilidad Real AI',
    chart_bottom_ai_sub: 'Salida del Modelo Poly Ai Claw',
    chart_bottom_implied_sub: 'Basado en precio del mercado',
    chart_marketProb: 'Prob. Implícita del Mercado',
    chart_aiProb: 'Probabilidad Real AI',
    chart_deviationArea: 'Zona de Desviación de Arbitraje',
    maxDeviation: 'Desviación Máxima',
    deviation: 'Desviación',
    flow_title: 'Flujo Completo de Estrategia',
    flow0_title: 'Monitorear Datos BTC',
    flow0_desc: 'Precio/volumen en tiempo real',
    flow1_title: 'Detección de Volatilidad',
    flow1_desc: '≥ 100 USD',
    flow2_title: 'Filtro de Tiempo',
    flow2_desc: 'Últimos 60 segundos',
    flow3_title: 'Evaluación de Win Rate',
    flow3_desc: '≥ 60-70%',
    flow4_title: 'Ejecución Automática',
    flow4_desc: 'Comprar YES/NO',
    flow5_title: 'Liquidación del Mercado',
    flow5_desc: '1 USDC',
    flow6_title: 'Ganancias Compuestas',
    flow6_desc: '3%-10%',
    risk0_title: 'Estructura de Control de Riesgo',
    risk0_i0: 'Límite de capital por evento < 5%',
    risk0_i1: 'Diversificación multi-evento',
    risk0_i2: 'Stop-loss dinámico AI',
    risk1_title: 'Estrategia de Tiempo',
    risk1_i0: 'Ejecutar en los últimos 60 segundos',
    risk1_i1: 'Evitar trading emocional',
    risk1_i2: 'Información más completa',
    risk2_title: 'Rendimiento Histórico',
    risk2_i0: 'Win rate histórico 80%-90%',
    risk2_i1: 'Ganancia promedio 3%-10%',
    risk2_i2: 'Modelo de arbitraje estable',
  },
  crossPlatform: {
    badge: 'Arbitraje Entre Plataformas',
    title1: 'PolyAi CLaw',
    title2: 'Lógica de Arbitraje de Mercado de Predicción Entre Plataformas',
    desc: 'Conectando Polymarket (Web3) y Kalshi (Fiat) — capturando desviaciones de precio con emparejamiento inteligente y ejecución ultrarrápida',
    polymarket: 'Polymarket',
    kalshi: 'Kalshi',
    web3: 'Web3',
    fiat: 'Fiat',
    claw: 'CLaw',
    matched: '✓ Emparejado',
    matching: 'Emparejando...',
    sec1_badge: '01',
    sec1_accuracy: 'Precisión 99%+',
    sec1_title: 'Emparejamiento Inteligente de Mercados',
    sec1_desc: 'Los eventos en ambas plataformas son vinculados automáticamente por IA semántica',
    sec2_badge: '02',
    sec2_ms: 'Ejecución en Milisegundos',
    sec2_title: 'Integración Unificada y Trading Ultrarrápido',
    sec2_desc: 'API/SDK unificado conecta múltiples plataformas, colocación de órdenes sincronizada en milisegundos',
    connected: 'Conectado · En Vivo',
    latency: 'Latencia de Orden',
    dailyEvents: 'Eventos Emparejados Diarios',
    successRate: 'Tasa de Éxito de Ejecución',
    platforms: 'Plataformas Sincronizadas',
    sec3_badge: '03',
    sec3_analytics: 'Live Analytics',
    sec3_title: 'Visualización de Datos de Arbitraje',
    sec3_desc: 'Desviación de precios en tiempo real, ganancias de arbitraje y tendencias de crecimiento',
    priceDeviation: 'Distribución de Desviación de Precios',
    volumeTitle: 'Volumen Mensual (K USDC)',
    h1Volume: 'Volumen Acumulado H1 (USDC)',
    arbIndicators: 'Métricas de Ventaja de Arbitraje',
    arbSuccess: 'Tasa de Éxito de Arbitraje de Spread',
    semanticAccuracy: 'Precisión de Emparejamiento Semántico',
    liquidity: 'Liquidez Entre Plataformas',
    hedgeCoverage: 'Tasa de Cobertura de Cobertura',
  },
  mathAlgo: {
    badge: 'Algoritmos Matemáticos Avanzados de Precisión',
    title1: 'El Arbitraje en Polymarket No Es',
    title2: 'Un Problema de Matemáticas Simple',
    quote: 'Mientras todavía estás calculando esto manualmente, el sistema quant ya está haciendo algo completamente diferente.',
    quoteHighlight1: 'calculando manualmente',
    quoteHighlight2: 'algo completamente diferente',
    ch0_title: '¿Qué Es el Arbitraje? ¿Por Qué Polymarket Tiene Tanto?',
    ch0_tag: 'Ineficiencia del Mercado',
    ch1_title: 'Arbitraje Entre Mercados: Dependencias Lógicas',
    ch1_tag: 'Matemáticas Combinatorias',
    ch2_title: 'Proyección de Bregman: Calculando el Tamaño Óptimo de Arbitraje',
    ch2_tag: 'Optimización Convexa',
    pipeline_title: 'Sistema de Arbitraje de Polymarket — Arquitectura Completa',
    layer0: 'Capa 1: Recopilación de Datos',
    layer1: 'Capa 2: Detección de Dependencias',
    layer2: 'Capa 3: Motor de Optimización de 3 Niveles',
    layer3: 'Capa 4: Ejecución y Gestión de Posiciones',
    annualProfit: 'Ganancia Total Anual Extraída: $39,688,585',
    venn_title: 'Dependencia Lógica: P(Ganar 5%) ⊆ P(Ganar)',
    contradiction: '¡Contradicción! P(subconjunto) > P(conjunto padre) → Señal de arbitraje activada',
    contradiction_sub: '0,55 > 0,48 → Contradicción lógica → Oportunidad de arbitraje',
    combinations: 'Combinaciones de Mercado',
    brutal: 'Enumeración bruta imposible',
    integerConstraints: 'Restricciones de Programación Entera',
    replaces: 'Reemplaza 16.384 enumeraciones',
    bregman_title: 'Divergencia KL vs Distancia Euclidiana',
    coreData: 'Datos Centrales',
    pipeline4: 'Pipeline de 4 Capas del Sistema',
    annualReturn: 'Ganancia Anual ≈ $39,7M',
    whyNotEnough_title: '¿Por qué "La Suma de Precios = $1" No es Suficiente?',
    singleMarket: 'Mercado Único — Parece Normal',
    crossMarket: 'Entre Mercados — Explosión Exponencial',
  },
  mathProfit: {
    ch3_title: 'Algoritmo Frank-Wolfe: Acercándose a la Respuesta Paso a Paso',
    ch3_tag: 'Algoritmo Iterativo',
    ch3_chapter: 'Capítulo 04',
    execTitle: 'Riesgo de Ejecución No Atómica',
    profitStructure: 'Estructura de Ganancias (Abr 2024 – Abr 2025)',
    totalProfit: 'Total: $39,688,585',
    top10: 'TOP 10 tomó el 20,5%',
    kellyFormula: 'Fórmula de Posición Kelly Modificada',
    preTrade: '4 Puntos de Control Previos al Trading',
    gate0: '¿Liquidez suficiente?',
    gate1: '¿Slippage aceptable?',
    gate2: '¿Sigue siendo rentable después del slippage?',
    gate3: 'Ganancia > $0,05 → Ejecutar',
  },
  safuFund: {
    badge: 'Garantía de Seguridad de Activos',
    title: 'Fondo SAFU de Polywin',
    titleHighlight: 'Fondo SAFU',
    desc: 'Reservas bloqueadas on-chain, transparentes y verificables en tiempo real — tus activos, los protegemos',
    reserveLabel: 'Total Reserve · USDC · Ethereum Mainnet',
    verified: 'Verificado On-chain',
    mainDesc: 'El equipo de Polywin ha bloqueado 10 millones de USDC como fondo de reserva de seguridad SAFU en la red principal de Ethereum.',
    mainDescHighlight: '10 millones de USDC',
    contractLabel: 'Dirección del Contrato',
    etherscanBtn: 'Verificar en Etherscan',
    stat0_label: 'Tamaño de Reserva',
    stat0_sub: 'USDC',
    stat1_label: 'Tasa de Bloqueo On-chain',
    stat1_sub: 'On-Chain',
    stat2_label: 'Verificable',
    stat2_sub: 'Real-time',
    stat3_label: 'Compensaciones Históricas',
    stat3_val: '$0',
    stat3_sub: 'Registro Sin Pérdidas',
    f0_title: 'Bloqueado On-chain',
    f0_desc: '100% de los fondos bloqueados en contratos inteligentes de la red principal de Ethereum',
    f1_title: 'Completamente Transparente',
    f1_desc: 'Cualquiera puede ver el saldo y el historial de transacciones a través de Etherscan en tiempo real',
    f2_title: 'Compensación Rápida',
    f2_desc: 'El proceso de compensación comienza dentro de las 72 horas de confirmar el incidente',
    f3_title: 'Auditoría Independiente',
    f3_desc: 'Agencias de seguridad de terceros auditan regularmente el código del contrato',
  },
  cta: {
    badge: 'Empieza Ahora',
    title1: 'Empieza a Usar',
    title2: 'Poly Ai Claw',
    title3: 'Intelligence Engine',
    desc: 'Sin experiencia en programación necesaria — configura estrategias de IA en 3 minutos',
    btn: 'Activar AI-Claw',
    trust0: 'Socio Oficial de Polygon',
    trust1: 'Certificado por Agencia de Auditoría',
    trust2: '10,000+ Usuarios Activos',
    trust3: '$50M+ Volumen Acumulado',
  },
  footer: {
    tagline: 'Poly Ai Claw Intelligence Engine',
    product: 'Producto',
    resources: 'Recursos',
    social: 'Redes Sociales',
    link0: 'Algoritmo Poly AI-Claw',
    link1: 'Sistema de Control de Riesgo',
    link2: 'API de Datos',
    link3: 'Documentación de Desarrollador',
    res0: 'Tutorial',
    res1: 'Casos de Estrategia',
    res2: 'Whitepaper',
    res3: 'Foro de la Comunidad',
    copyright: '© 2026 PolyWin. All rights reserved.',
    privacy: 'Política de Privacidad',
    terms: 'Términos de Servicio',
  },
};
